import { useGetAllReturnWorkflowsSuspense } from "@babackapp/private-api-client/client/use-get-all-return-workflows";

/**
 * Whether at least one active workflow listens to the disapproval. Gates nothing
 * — the shop toggle governs this screen — it only decides whether we promise the
 * customer an email, the reason stopping at the activity feed otherwise.
 *
 * Suspense on purpose: the non-suspense variant answers `false` while loading,
 * flashing the "no workflow" warning on a shop that has one.
 */
export function useHasDisapprovalWorkflow(shopId: string): boolean {
  const { data: workflows } = useGetAllReturnWorkflowsSuspense(shopId);

  return workflows.some(
    (workflow) =>
      workflow.isActive &&
      workflow.trigger.data.triggerType === "return_disapproved",
  );
}
